<div class="my-bets-container">
  <!-- TODO: Icon -->
  <app-breadcrumb [title]="'My Bets' | transloco" navIcon="mybets"></app-breadcrumb>
  <app-my-bets></app-my-bets>
</div>
